
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { loginSuccess, registerUserSuccessful } from "../../store/actions";
import { post } from "../../helpers/api_helper";
import { toast } from "react-toastify";
const PageFive = (props) => {

  const [email, setEmail] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");

  useEffect(() => {
    getEmail();
    // console.log('step two props', props);
  }, []);

  useEffect(()=>{
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  },[])

  const getEmail = async () => {
    var data = await localStorage.getItem("authUser");
    if (data) {
      data = JSON.parse(data);
      setEmail(data?.email);
    }
  }

  const cPassword = () =>{

  }

  // console.log('props data five',props)
  const handleValidSubmit = (event, values) => {


    // console.log('step 1 before', values);
    const education = [
      {
        type: '10th pass',
        year: values.ten_year,
        mark: values.ten_mark,
        totalMark: values.ten_totalMark,
        program: values.ten_program


      },
      {
        type: '12th pass',
        year: values.twel_year,
        mark: values.twel_mark,
        totalMark: values.twel_totalMark,
        program: values.twel_program


      },
      {
        type: 'diploma',
        year: values.diploma_year,
        mark: values.diploma_mark,
        totalMark: values.diploma_totalMark,
        program: values.diploma_program


      },
      {
        type: 'bachelor',
        year: values.master_year,
        mark: values.master_mark,
        totalMark: values.master_totalMark,
        program: values.master_program


      },
      {
        type: 'master',
        year: values.phd_year,
        mark: values.phd_mark,
        totalMark: values.phd_totalMark,
        program: values.phd_program


      }
    ]
    // console.log('education details', education);
    const body = {
      step: 3,
    ...values
    }
    if(cpassword == password)  {
    post('/login', body)
      .then((json => {
        // console.log('VERIFICATION', json);
        if (json.statusCode == 200) {
        //   props.history.push("/login");
         localStorage.removeItem('email');
          loginSuccess(json?.data);
          localStorage.setItem("authUser", JSON.stringify(json?.data));
        toast.success(json.message);
        var opprtunity_path = localStorage.getItem('opprtunity');
        // console.log('opprtunity_path',opprtunity_path);
        if(opprtunity_path){
         props.history.push("/opportunity/"+opprtunity_path);

        }else{
          props.history.push("/");
        }


        }else{
          toast.error(json.error);
        }
      }))
    }else{
      toast.error("Passwords don't match.")
    }
  }

  return (
    <AvForm
      onValidSubmit={(e, v) => {
        handleValidSubmit(e, v)
      }}
    >
      <Row>
        <Col lg={12} md={12}>
          <h3 className="heading-title pt-4">Verification</h3>
        </Col>
        <Col lg={4} md={6}>
        <AvField type="email" name="email" value={props.email} disabled label="Email" required />
        </Col>
        <Col lg={4} md={6}>
          <AvField type="text" name="otp" label="Otp" required />
        </Col>
        <Col lg={4} md={6}>
          <AvField type="password" name="password" onChange={(e)=>setPassword(e.target.value)} label="Password" required />
        </Col>
        <Col lg={4} md={6}>
          <AvField type="password" name="confirmpassword" onChange={(e)=>setCpassword(e.target.value)} label="Confirm Password" required />
        </Col>
        <Col lg={12}>
          <AvField type="checkbox" name="avFieldCheckbox" label="I agree that all the above information is accurate to the best of my knowledge." required />
          </Col>
        <FormGroup className="btn_box">
          <Button
            onClick={() => props.onButtonClick("pagefour")}
            className="common-btn back_m">Back</Button>
          <Button
            type="submit"
            className="common-btn">Submit</Button>
        </FormGroup>
      </Row>
    </AvForm>
  );
};


export default PageFive;